import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromCatalog from './reducers/catalog.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CatalogEffects } from './effects/catalog.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromCatalog.catalogFeatureKey, fromCatalog.reducer),
    EffectsModule.forFeature([CatalogEffects])
  ]
})
export class CatalogStoreModule {}
